import React from 'react';
import { useParams } from 'react-router-dom';
import { ProjectPanelLayout } from './ProjectPanelLayout';
import { ShareProject } from './ShareProject';
import { useLocale } from '../contexts/LocaleContext';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../contexts/ToastContext';
import { useProjectAccess } from '../contexts/ProjectAccessContext';
import { PROJECT_SECTION_ICONS } from '../utils/concept-icons';

export const ProjectSharing: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const { t } = useLocale();
  const { token } = useAuth();
  const { showToast } = useToast();
  const { canManageSharing, isLoading } = useProjectAccess();

  if (isLoading) {
    return <ProjectPanelLayout title={t('share_project')} titleIcon={PROJECT_SECTION_ICONS.share} loading />;
  }

  if (!canManageSharing) {
    return (
      <ProjectPanelLayout title={t('share_project')} titleIcon={PROJECT_SECTION_ICONS.share}>
        <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '0.5rem' }}>{t('access_denied')}</h2>
        <p>{t('no_permission')}</p>
      </ProjectPanelLayout>
    );
  }

  return (
    <ProjectPanelLayout title={t('share_project')} titleIcon={PROJECT_SECTION_ICONS.share}>
      <ShareProject
        token={token}
        projectId={projectId}
        t={t}
        showToast={showToast}
      />
    </ProjectPanelLayout>
  );
};
